export const interestOptions = ["Infrastructure", "Housing", "Transportation","Safety","Education",
                                "Health","Economy","Environment","Community","Services"]


export const queryCategories = [
    { value: 'Infrastructure', label: 'Infrastructure' },
    { value: 'Housing', label: 'Housing' },
    { value: 'Transportation', label: 'Transportation' },
    { value: 'Safety', label: 'Safety' },
    { value: 'Health', label: 'Health' },
    { value: 'Economy', label: 'Economy' },
    { value: 'Education', label: 'Education' },
    { value: 'Environment', label: 'Environment' },
    { value: 'Community', label: 'Community' },
    { value: 'Services', label: 'Services' },
]
